// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.io.io-image > .content {
  width: 100%;
  max-width: 100%; /* Override default value from io-abstract */
  flex-basis: 100%; /* Override default value from io-abstract */
}

.io-img {
  height: 100%;
  width: 100%;

  img[data-role="image"] {
    object-fit: contain;
    height: 100%;
    width: 100%;

    transition: transform 1s ease;
  }

  img[data-decorator] {
    position: absolute;
    bottom: 0;
    right: 0;

    object-fit: contain;
    background-color: gray;
    border-radius: 10px;
    padding: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./frontend/widget/io-image.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe,EAAE,4CAA4C;EAC7D,gBAAgB,EAAE,4CAA4C;AAChE;;AAEA;EACE,YAAY;EACZ,WAAW;;EAEX;IACE,mBAAmB;IACnB,YAAY;IACZ,WAAW;;IAEX,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;;IAER,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;EACd;AACF","sourcesContent":[".io.io-image > .content {\n  width: 100%;\n  max-width: 100%; /* Override default value from io-abstract */\n  flex-basis: 100%; /* Override default value from io-abstract */\n}\n\n.io-img {\n  height: 100%;\n  width: 100%;\n\n  img[data-role=\"image\"] {\n    object-fit: contain;\n    height: 100%;\n    width: 100%;\n\n    transition: transform 1s ease;\n  }\n\n  img[data-decorator] {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n\n    object-fit: contain;\n    background-color: gray;\n    border-radius: 10px;\n    padding: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
